module.exports = __webpack_public_path__ + "img/rate-my-flowers.6c69993c.png";